import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollTop } from "../lib/scroll";

export default function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
}
